export enum CUSTOM_SORT_OPTIONS {
  TIME_OUT_OF_RANGE = 'Time out of Range',
  TIME_IN_RANGE = 'Time in Range',
  HYPER_EVENTS = '# Hyperglycemia Events',
  HYPO_EVENTS = '# Hypoglycemia Events',
  HIGHEST_VALUE = 'Highest Value',
  LOWEST_VALUE = 'Lowest Value'
}